import moment from 'moment';
import { formatDateList } from '../util/date/date-list'

class Comment {
  private id
  private commentText
  private ngayTao
  private hoTen

  constructor(options) {
    this.id = Math.random()
    this.commentText = options.message || ''
    this.ngayTao = options.ngay_tao
      ? formatDateList(new Date(options.ngay_tao))
      : ''
    this.hoTen = options.name || ''
  }
}

export default Comment
